(function(){
     'use strict';

     angular
        .module('appback')
        .factory('CuentaappService', CuentaappService);

        CuentaappService.$inject = ['$http'];

    function CuentaappService($http){

        var service= {
           getInfoCentro:getInfoCentro,
           getFacturacionPrevista:getFacturacionPrevista
        };

        return service;
 		function getInfoCentro(centro_sso,month,year,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/cuentaapp/getinfocentro', { params : { centro_sso:centro_sso, month:month, year:year } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getFacturacionPrevista(centro_sso,month,year,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            $http.get('/backend/cuentaapp/getfacturacionprevista', { params : { centro_sso:centro_sso, month:month, year:year} }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

      
    }
})();